export enum AtlassianAccountMigrationStage {
  done = 'done',
  ineligible = 'ineligible',
  onboarding = 'onboarding',
  legacyOnboardingV2 = 'legacyOnboardingV2',
  newlyManaged = 'newlyManaged',
  migration = 'migration',
  emailHygiene = 'emailHygiene',
  confirmEmail = 'confirmEmail',
}
